<template>
    <Row :gutter="15">
        <Col v-for="campaign of campaigns" :key="campaign._id" :xs="24" :sm="12" :md="8" :lg="6">
            <CampaignCard
                :campaign="campaign"
                @duplicate="onDuplicate(campaign._id)"
                @edit="onEdit(campaign._id)"
                @manageTeam="onManageTeam(campaign._id)"
                @setSection="onSetSection(campaign._id)"
            />
        </Col>
    </Row>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

import CampaignCard from "@/components/Campaign/CampaignCard.vue";
import { type Campaign } from "@/types/types";

export default defineComponent({
    name: "CampaignsList",
    components: { CampaignCard },
    props: {
        campaigns: {
            type: Array as PropType<Campaign[]>,
            required: true
        }
    },
    emits: ["duplicate", "edit", "manageTeam", "setSection"],
    methods: {
        onDuplicate(campaignId: string) {
            this.$emit("duplicate", campaignId);
        },
        onEdit(campaignId: string) {
            this.$emit("edit", campaignId);
        },
        onManageTeam(campaignId: string) {
            this.$emit("manageTeam", campaignId);
        },
        onSetSection(campaignId: string) {
            this.$emit("setSection", campaignId);
        }
    }
});
</script>
